(function (app) {
    app.provider("stickyNoteApi", [
        function () {
            this.$get = ["crmApiGateway", function (crmApiGateway) {
                var service = {};

                service.getCurrentUserOpenStickyNotesThisMonth = function () {
                    return crmApiGateway.getArray("/StickyNotes/User/Me/Open/ThisMonth");
                };

                service.getCurrentUserStickyNotesForDates = function(startDay, startMonth,
                    startYear, endDay, endMonth, endYear) {
                    return crmApiGateway.getArray("/StickyNotes/Me/Start/" + startDay +
                        "/" + startMonth + "/" + startYear + "/End/" + endDay +
                        "/" + endMonth + "/" + endYear);
                };

                service.getCurrentUserOpenStickyNotesNextThreeMonths = function() {
                    return crmApiGateway.getArray("/StickyNotes/User/Me/Open/NextThreeMonths");
                };

                service.getCurrentUserOpenStickyNotes = function (month, year) {
                    return crmApiGateway.getArray("/StickyNotes/User/Me/Open/" + month + "/" + year);
                };

                service.getClientOpenStickyNotesForCurrentUser = function (clientId) {
                    return crmApiGateway.getArray("/StickyNotes/User/Me/Client/" + clientId + "/Open");
                };

                service.getClientOpenStickyNotesCount = function (clientId) {
                    return crmApiGateway.get("/StickyNotes/Client/" + clientId + "/Open/Count");
                };

                service.getOpenClientStickyNote = function(clientId, stickyNoteId) {
                    return crmApiGateway.get("/StickyNotes/Client/" + clientId + "/" + stickyNoteId);
                };

                service.addClientStickyNote = function (stickyNote, clientId) {
                    return crmApiGateway.post("/StickyNotes/Client/" + clientId, stickyNote);
                };

                service.addNote = function (stickyNoteId, note) {
                    return crmApiGateway.put("/StickyNotes/" + stickyNoteId + "/AddNote", note);
                };

                service.updateNote = function (stickyNoteId, note) {
                    return crmApiGateway.put("/StickyNotes/" + stickyNoteId + "/UpdateNote", note);
                };

                service.removeNote = function (stickyNoteId, note) {
                    return crmApiGateway.put("/StickyNotes/" + stickyNoteId + "/RemoveNote", note);
                };

                service.update = function (stickyNote) {
                    return crmApiGateway.put("/StickyNotes", stickyNote);
                };

                service.complete = function (id) {
                    return crmApiGateway.delete("/StickyNotes/Completed/" + id);
                };

                return service;
            }];
        }
    ]);
})(window.app); //jshint ignore:line